import styled from 'styled-components';

export const HeroContainer = styled.div`
    background: #0c0c0c;
    display: flex;
    justify-content: center;
    padding: 0 30px;
    height: 900px;
    position: relative;
    z-index: 1;
    overflow-x: hidden;

    :before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, 
            rgba(0,0,0,0.2) 0%,
            rgba(0,0,0,0.6) 100%
            ), linear-gradient(180deg, 
                rgba(0,0,0,0.2) 0%, 
                transparent 100%);
        z-index: 2;
    }
`;

/* Add :before styles */

export const HeroBg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

export const Img = styled.img`
    width:100%;
    height:100%;
    object-fit: cover;
    overflow: hidden;
`;


export const HeroContent = styled.div`
    z-index: 3;
    max-width: 1200px;
    position: absolute;
    margin-top: 200px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const HeroH1 = styled.h1`
    color: #fff;
    font-size: 48px;
    text-align: center;
    font-weight: 500;

    @media screen and (max-width: 768px) {
        font-size: 40px;
    }

    @media screen and (max-width: 480px) {
        font-size: 32px;
    }
`;

export const HeroP = styled.p`
    margin-top: 24px;
    color: #fff;
    font-size: 1.3rem;
    text-align: center;
    max-width: 600px;
    font-weight: 300;

    @media screen and (max-width: 768px) {
        font-size: 24px;
    }

    @media screen and (max-width: 480px) {
        font-size: 18px;
    }
`;

export const HeroBtnWrapper = styled.div`
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Profile = styled.img`
    margin-top: 50px;
     border-radius: 50%;
     width: 40%;
     -webkit-box-shadow: 8px 5px 15px 5px rgba(30,30,30,0.42); 
box-shadow: 8px 5px 15px 5px rgba(30,30,30,0.42);
`;